import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { App } from './app';

const appContainer = document.createElement('div');
appContainer.setAttribute('id', 'app-root');
document.body.appendChild(appContainer);
const root = createRoot(appContainer);

const elementToRender = (
    <StrictMode>
        <HashRouter>
            <App />
        </HashRouter>
    </StrictMode>
);

root.render(elementToRender);
